<template>
  <v-form @submit.prevent="search" role="form">
    <v-text-field
      ref="field"
      append-icon="fa-search"
      @click:append="search"
      placeholder="Buscar coberturas"
      height="30px"
      v-model="q"
      hide-details
      solo
      rounded
      dense
      block
      focus
    ></v-text-field>
  </v-form>
</template>

<script>
export default {
  data: () => ({
    q: "",
  }),
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    search() {
      this.$router.push({ path: "/busca", query: { q: this.q } });
      this.q = "";
    },
  },
};
</script>
